export const toggleZendeskLegacy = () => {
  // https://developer.zendesk.com/api-reference/widget/core/
  window?.zE('webWidget', 'toggle');
};

export const toggleZendeskNew = () => {
  // https://developer.zendesk.com/api-reference/widget-messaging/web/core/
  const chatWindow = document.querySelector("iframe[title='Messaging window']");
  const isVisible = chatWindow?.getAttribute('tabindex') === '0';
  if (isVisible) {
    window.zE('messenger', 'close');
    window.zE('messenger', 'hide');
  } else {
    window.zE('messenger', 'show');
    window.zE('messenger', 'open');
  }
};

export const toggleAda = () => {
  window?.adaEmbed?.toggle();
};

export const openChat = (hasSupportLiveChat: boolean, SupportChatAgentWorkspace: boolean) => {
  if (hasSupportLiveChat) {
    // Plus and Premier support packages have access to the Zendesk Chat widget.
    if (SupportChatAgentWorkspace) {
      // Zendesk Chat is being updated on April 2024
      toggleZendeskNew();
    } else {
      toggleZendeskLegacy();
    }
  } else {
    // Standard support packages only have access to the Ada chat.
    toggleAda();
  }
};
